<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import CutoffTime from "@retailer/svelte/Shared/DistributorInfo/CutoffTime.svelte";
  import OrderMinimums from "@retailer/svelte/Shared/DistributorInfo/OrderMinimums.svelte";
  import Notes from "@retailer/svelte/Shared/DistributorInfo/Notes.svelte";

  export let distributorName: string;
  export let cutoffTime: string = "";
  export let minPurchase: number | null;
  export let minQuantity: string | null;
  export let notes: string = "";
  export let showModal: boolean;

  const closeModal = () => {
    showModal = false;
  };

</script>

<Modal bind:show={showModal} fizzModal={true} medium={true} overflowY="scroll">
  <section class="fizz-modal-main fizz-text-medium fizz-inset-square-24">
    <header class="fizz-space-between fizz-stack-8">
      <h4 class="fizz-heading-4">Order requirements</h4>
      <div on:click={closeModal}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="14" width="14" />
      </div>
    </header>
    <div class="fizz-stack-16">These are order requirements provided by your distributor.</div>
    <div class="fizz-bordered fizz-inset-square-16 fizz-flow-12 fizz-stack-16">
      <div class="fizz-text-strong">
        {distributorName}:
      </div>

      {#if !!cutoffTime}
        <div class="fizz-flex-row fizz-align-content-start">
          <CutoffTime {cutoffTime} />
        </div>
      {/if}

      {#if !!minPurchase || !!minQuantity}
        <div class="fizz-flex-row fizz-align-content-start">
          <OrderMinimums {minPurchase} {minQuantity} truncateOrderMinimum={false} />
        </div>
      {/if}

      {#if !!notes}
        <div class="fizz-flex-row fizz-align-content-start">
          <Notes {notes} />
        </div>
      {/if}
    </div>
  </section>
</Modal>
